import { endOfDay } from 'date-fns';
import { DateRangeObject } from '@models/date-range';
import { toDateString, toValidDate } from '@/utils/date-utils';

export interface ClosedDateRange {
  start: Date;
  end: Date;
}

export function closeOpenEnd(range: Partial<DateRangeObject> | null | undefined): ClosedDateRange | undefined {
  const start = toValidDate(range?.start);
  if (!start) return undefined;
  return { start, end: endOfDay(toValidDate(range?.end) ?? start) };
}

export function toSelectedRange(range: Partial<DateRangeObject> | null | undefined): { start: string; end: string } | undefined {
  const closed = closeOpenEnd(range);
  if (!closed) return undefined;
  return { start: closed.start.toISOString(), end: closed.end.toISOString() };
}

export function toLocalDateBounds(range: Partial<DateRangeObject> | null | undefined): { fromDate?: string; toDate?: string } {
  const closed = closeOpenEnd(range);
  if (!closed) return { fromDate: undefined, toDate: undefined };
  return { fromDate: toDateString(closed.start), toDate: toDateString(closed.end) };
}
